import { StatAmount, StatAmountUsd, StatLabel } from '@ui/components/Stats';
import { useTradingPair } from '@ui/features/Trade/store/useTradingPair';
import { useTradePairInfosByPairBaseSymbol } from '@ui/hooks/trade/useTradePairInfos';
import { GetVolumeRangeEnum } from '@ui/services/backend/generated';
import { useBaseTradePairsVolume } from '@ui/services/backend/hooks/useTradePairVolume';
import { useTranslation } from 'next-i18next';
import { Box, Flex } from 'styled-system/jsx';

export const Vol24h = () => {
  const { t } = useTranslation();
  const tradingPair = useTradingPair((v) => v.useTradingPair());
  const tradingPairsInBaseSymbol = useTradePairInfosByPairBaseSymbol(
    tradingPair.baseSymbol,
  );
  const { data: vol24hInBaseSymbol } = useBaseTradePairsVolume({
    pairBaseAddresses: tradingPairsInBaseSymbol?.map((v) => v.address) ?? [],
    range: GetVolumeRangeEnum.All,
  });

  return (
    <>
      <Flex minW="150px" direction="column" justifyContent="between">
        <StatLabel>
          {t('common.Cumulative Volume', {
            symbol: 'USD',
          })}
        </StatLabel>
        <StatAmountUsd
          mt="2px"
          value={vol24hInBaseSymbol?.volumeUSDSum}
          opts={{
            kmb: true,
          }}
          data-cy={`24H-VolumeUSD-${tradingPair?.pairName}`}
          data-cy-value={vol24hInBaseSymbol?.volumeUSDSum}
        />
      </Flex>
    </>
  );
};
